<template lang="pug">
.landmarks
  .landmarks-intro
    AppTitle(:title="$t('mantra')")

    Query(
      :initialValue="artworks"
      :query="require('~/graphql/Artwork.gql').Artworks"
      :limit="12"
      :variables="{ query, type: 'LANDMARK' }"
      v-slot="{ items }"
    )
      .grid.is-ultrawide-4.is-widescreen-4.is-desktop-4.is-6.is-landmarks.u-mt-sm
        .column(v-for="landmark in items")
          AppCard.is-small.u-textCenter(:img="landmark.thumb" ratio="5:2" :title="landmark.title" :url="`/tools/doodles/landmarks/${landmark.slug}`" @click="selectedItem = landmark")

  TheaterOverlay(
    :isActive="!!selectedItem.id"
    :title="selectedItem.title"
    :image="selectedItem.thumb"
    @close="onLeave"
  )
    //- template(#buttons)
    //-   a.landmark-overlay-download(v-if="selectedItem" :href="`/files/${selectedItem.file.id}`")
    //-     AppIcon(name="download")
</template>

<script>
import { debounce } from 'throttle-debounce';
import { load } from '~/directives';
import Query from '~/components/Query';
import TextInput from '~/components/inputs/TextInput';
import TheaterOverlay from '~/components/TheaterOverlay';
import { generateSeoMeta } from '~/utils/seo';
import { Artworks, Artwork } from '~/graphql/Artwork.gql';

export default {
  key: 'patterns',
  preserveScrollPosition: true,
  meta: {
    theme: 'dark',
    logoText: 'landmarks'
  },
  components: {
    TextInput,
    Query,
    TheaterOverlay
  },
  directives: {
    load
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true }),
  async asyncData({ app, from, params }) {
    if (from && from.name.indexOf('ideas-graphics-landmarks-slug') === 0) {
      return {};
    }

    const [artworks, artwork] = await Promise.all([
      app.$api.query({
        query: Artworks,
        variables: {
          first: 12,
          type: 'LANDMARK'
        }
      }),
      params.slug
        ? app.$api.query({
            query: Artwork,
            variables: {
              slug: params.slug
            }
          })
        : undefined
    ]);

    let selectedItem = {
      id: null,
      thumb: '',
      title: '',
      file: {
        id: ''
      }
    };

    if (artwork) {
      selectedItem = artwork.data.artwork;
    }

    return {
      artworks: artworks.data.artworks,
      selectedItem
    };
  },
  data: () => ({
    query: '',
    searchQuery: '',
    selectedItem: {
      id: null,
      thumb: '',
      title: '',
      file: {
        id: ''
      }
    }
  }),
  watch: {
    searchQuery(value) {
      this.updateQuery(value);
    }
  },
  methods: {
    onLeave() {
      this.selectedItem = {
        id: null,
        thumb: '',
        title: '',
        file: {
          id: ''
        }
      };
      this.$router.localePush('/tools/doodles/landmarks');
    },
    updateQuery: debounce(400, function(value) {
      this.query = value;
    })
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Landmarks",
    "pageDesc":"Explore hundreds of free illustration for famous landmarks that you can download and use in your next branding or design project. ",
    "mantra": "Discover |the world"
  },
  "ar": {
    "pageTitle":"المعالم",
    "pageDesc":"استكشف مئات المعالم المشهورة المجانية المتاحة للتحميل والاستخدام في مشروعك القادم لتصميم العلامة التجارية أو التصميم الجرافيكي.",
    "mantra":"استكشف العالم"
  }
}
</i18n>

<style lang="stylus">
$clBg = #222

div.app.is-patternest
  overflow: hidden
  background: $clBg
  font-weight: $fontWeight-normal

  .header.is-scroll
    background: $clBg

  .theater-overlay
    background: alpha($clBg, 0.9)

    &-title
      color: $clWhite

    &-icons
      color: $clWhite

      >*
        margin: 0 5px

      .icon
        color: $clWhite
        fill: $clWhite

        &:hover
          fill: $clPrimary

.patternest
  h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6, .button-link
    font-weight: $fontWeight-medium

  &-share
    margin: 0 -5px

    >a
      margin: 5px

  &-intro
    padding-top: unitRes(50, 200)
    position: relative
    z-index: 2

  .grid.is-patternest
    margin-right: -5px
    margin-left: -5px

    >.column
      padding-right: 5px
      padding-left: 5px

    .card
      margin-bottom: 10px

      &-body
        display: none
</style>
